

import StreamingWrapper from 'parts/StreamingWrapper';
import CinedaptAntiPiracy from './CinedaptAntiPiracy';
import StreamingProviders from './StreamingProviders';
import { W780H1170 } from 'config/image-sizes';
import dynamic from 'next/dynamic';

const MovieStreaming = ({
  baseUrl,
  movie
}) => (
  <StreamingWrapper>
    <div style={{paddingLeft:'20px', paddingRight:'20px'}}>
      <CinedaptAntiPiracy
        baseUrl={baseUrl}
        movie={movie} />
      <StreamingProviders
        baseUrl={baseUrl}
        streaming={movie.streaming} />
    </div>
  </StreamingWrapper>
);

export default MovieStreaming;
